import { Flex, SxStyleProp } from 'theme-ui';
import { useSelector } from 'react-redux';
import { isSidebarOpen } from 'modules/sidebar';
import { Sidebar } from 'types/Sidebar';
import { FC, memo } from 'react';
import { ProjectFilesBar } from '../ProjectFilesBar';
import { WEBSITE_URL } from 'utils/env';

const sxLogoStyles: SxStyleProp = {
  position: 'relative',
  display: 'block',
  height: '100%',
  cursor: 'pointer',
  overflow: 'hidden'
};

type HeaderProps = {
  isOpen: boolean;
};

const HeaderLogoBase: FC<HeaderProps> = memo(({ isOpen }) => {
  return (
    <div
      sx={{
        width: !isOpen ? '80px' : '444px',
        height: '62px',
        marginBottom: '4px',
        bg: 'background',
        borderRadius: '8px'
      }}
    >
      <Flex sx={{ alignItems: 'center', height: '100%' }}>
        <div sx={{ marginLeft: isOpen ? '10px' : '16px' }}>
          <a href={`${WEBSITE_URL}/create`}>
            <img
              style={{
                display: !isOpen ? 'block' : 'none'
              }}
              sx={{
                ...sxLogoStyles,
                width: '48px'
              }}
              src="https://cdn140.picsart.com/92002489833603039019.png"
              loading="lazy"
              width="48"
              height="48"
              alt="PicsArt"
            />
            <img
              style={{
                display: isOpen ? 'block' : 'none'
              }}
              sx={{
                ...sxLogoStyles,
                width: '104px'
              }}
              src="http://cdn140.picsart.com/42562349740725815550.svg"
              loading="lazy"
              width="104"
              height="24"
              alt="PicsArt"
            />
          </a>
        </div>
        {isOpen && <ProjectFilesBar />}
      </Flex>
    </div>
  );
});

const HeaderLogo = () => {
  const isOpen = useSelector(isSidebarOpen(Sidebar.ToolPanel));
  return <HeaderLogoBase isOpen={isOpen} />;
};

export default HeaderLogo;
